<script setup>
  import { ref } from 'vue'
  import { useLocalePath } from '#i18n'

  const headerRef = ref(null)

  const localePath = useLocalePath()
  const { menuIrol } = useMainMenuIrol()

  const updateHeaderHeight = () => {
    if (headerRef.value) {
      const height = headerRef.value.offsetHeight
      document.documentElement.style.setProperty('--header-height', `${height}px`)
    }
  }
  // const authStore = useAuthStore()
  // const user = computed(() => authStore.user)

  onMounted(() => {
    window.addEventListener('scroll', updateHeaderHeight)
    window.addEventListener('resize', updateHeaderHeight)
    updateHeaderHeight()
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', updateHeaderHeight)
    window.removeEventListener('resize', updateHeaderHeight)
  })
</script>

<template>
  <div ref="headerRef" class="w-full bg-white border-b border-slate-200 relative z-[1100]">
    <div class="container flex items-center justify-between">
      <div class="flex">
        <NuxtLink :to="localePath({ name: 'actions' })" class="flex items-center md:overflow-hidden m-2">
          <span class="sr-only">UIA</span>
          <picture>
            <source srcset="/logo/uia-irol-logo.webp" type="image/webp" />
            <img
              :class="['w-auto object-contain m-0 xl:mx-0 h-8 md:h-10 ']"
              src="@/public/logo/uia-irol-logo.png"
              alt="website home page"
            />
          </picture>
        </NuxtLink>
      </div>
      <div class="flex items-center justify-end w-full">
        <div class="flex space-x-6 hidden md:flex">
          <div
            v-for="item in menuIrol"
            :key="item.title"
            class="flex items-center group font-medium text-sm transition-colors"
          >
            <NuxtLink
              :to="localePath({ name: item.path, params: item.params || {} })"
              class="flex items-center"
              :class="item.linkCss"
            >
              <div class="p-2 rounded mr-3" :class="item.iconCss">
                <font-awesome class="fa-fw" :icon="['fal', item.icon]" />
              </div>
              <span>{{ item.title }}</span>
            </NuxtLink>
          </div>
        </div>

        <MenuBurgerIrol class="md:hidden ml-3 my-auto" />
      </div>
    </div>
  </div>
</template>

<style scoped>
  :deep(.vsm-link) {
    line-height: normal !important;
    display: flex;
    align-items: center;
    height: 100%;
  }
</style>
